import SI, { Spirit } from '../Common/SI'
import './SpiritName.css'

export interface SpiritNameProps {
	spirit: Spirit
}

export function SpiritName(props: SpiritNameProps): JSX.Element {

	const nicknameIndex = props.spirit.name.indexOf(props.spirit.nickname)

	return (
		<span className={`spirit ${SI.expansionClass.get(props.spirit.expansion)}`}>
			{props.spirit.name.substring(0, nicknameIndex)}
			<span className="nickname">{props.spirit.nickname}</span>
			{props.spirit.name.substring(nicknameIndex + props.spirit.nickname.length)}
		</span>
	)
}
